import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.system.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-system-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.system.item/view.scss */
/* src/app/page.admin.system.item/view.scss: no such file or directory */`],
})
export class PageAdminSystemItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public item:any;

    public async ngDoCheck() {
        this.item = WizRoute.segment.item;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
    }
}

export default PageAdminSystemItemComponent;